import { FC, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

import GreenChunk from '@/components/ReactIntlChunks/GreenChunk';
import FAQItem from '@Landing/Systems/FAQItem/FAQItem';

import FAQBottomBanner, {
  BottomBannerProps,
} from './BottomBanner/BottomBanner';
import messages from './messages';

import useStyles from './styles';

type Message = {
  id: string;
  defaultMessage: string;
};

type Question = {
  iconText: string;
  description: Message;
  question: Message;
};

type Props = {
  questions: Question[];
  bottomBannerProps: BottomBannerProps;
};

type Compound = {
  BottomBanner: FC<PropsWithChildren<BottomBannerProps>>;
};

const FAQ: FC<PropsWithChildren<Props>> & Compound = ({
  questions,
  children,
}) => {
  const { classes } = useStyles();

  return (
    <article className={classes.faq}>
      <div className={classes.container}>
        <Typography variant="titleMd" component="h2" className={classes.title}>
          <FormattedMessage {...messages.title} />
        </Typography>
        {questions.map(({ iconText, description, question }, i) => (
          <FAQItem
            key={i}
            iconText={iconText}
            question={<FormattedMessage {...question} />}
            description={
              <FormattedMessage
                {...description}
                values={{
                  strong: (chunk) => (
                    <span className={classes.strongText}>{chunk}</span>
                  ),
                  green: GreenChunk,
                }}
              />
            }
          />
        ))}
        {children}
      </div>
    </article>
  );
};

FAQ.BottomBanner = FAQBottomBanner;

export default FAQ;
